import React, { useEffect, useState } from 'react';

import { ImSpinner8 } from 'react-icons/im';
import CardProductCart from '../Cart/CardProductCart';
import CartValueDetails from '../Cart/CartValueDetails';
import { formatCurrency } from '../../../Utils/Formatters';
import ButtonPrimary from '../../Form/ButtonPrimary';
import ProofPayment from '../Cart/ProofPayment';
import Drawer from '../Drawer';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { useCartContext } from '../../../Contexts/CartContext';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';
import Badge from '../Badge';
import { getOrderTypeLabelById } from '../../../Utils/Constants/Order';
import { ORDER_STATUS_DONE } from '../../../Utils/Constants/Checkout';
import { ORDER_TYPE_STORE_COUNTER_ID } from '../../../Utils/Constants/Service';
import { useTranslation } from 'react-i18next';
import { MdOutlineTableRestaurant } from 'react-icons/md';

interface OrderDetailsProps {
    order: any,
    loading: boolean;
    onClose: CallableFunction;
}
const OrderDetails = ({ order, loading, onClose }: OrderDetailsProps) => {

    const { t } = useTranslation();
    const { showProofPayment, setShowProofPayment } = useCartContext();
    const [ isProofPaymentButtonVisible, setIsProofPaymentButtonVisible ] = useState<boolean>(false);
    const { isMobile } = useLayoutContext();

    const handleProofPayment = () => {
        setShowProofPayment(true);
    }

    useEffect(() => {
        setIsProofPaymentButtonVisible(
            Boolean(
                order
                && order.status === ORDER_STATUS_DONE
                && !order.cart.cart_pdv_validation
                && order.type === ORDER_TYPE_STORE_COUNTER_ID
            )
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order]);

    return (
        <>
            <section className='flex flex-col p-4 pb-0 h-full gap-4 justify-between'>
                {loading
                    ? <div className="flex items-center justify-center gap-1 h-full text-gray-500"><ImSpinner8 className="animate-spin" /> <span>{t('layout.loading')}</span></div>
                    :
                        order &&
                            <section className="relative flex flex-col justify-between h-full">
                                <div className='relative flex flex-col gap-3 w-full h-full md:overflow-y-auto'>
                                    <div className='relative h-full min-h-24'>
                                        <div className='flex flex-col divide-y divide-gray-100'>
                                            {order.cart?.items?.map((product: any, index: number) =>
                                                <CardProductCart
                                                    product={product}
                                                    key={index}
                                                    showButtonsIncDec={false}
                                                    cartFinished={true}
                                                />
                                            )}
                                        </div>
                                        <BoxContentEndScrollbars message={t('products.end_of_list')} />
                                    </div>
                                </div>

                                <div className="sticky bottom-0 grid gap-3 pb-4 pt-2 w-full bg-white/75 backdrop-blur-sm">
                                    <div className="flex items-center gap-1">
                                        <Badge outline className='text-nowrap leading-none py-1 -ml-0.5 normal-case text-xs'>
                                            {getOrderTypeLabelById(order.type)}
                                        </Badge>

                                        {order.cart.table &&
                                            <Badge outline className='text-nowrap leading-none py-1 text-xs'>
                                                <div><MdOutlineTableRestaurant /></div>
                                                {order.cart.table.name}
                                            </Badge>
                                        }
                                    </div>

                                    <div className="grid w-full text-sm">
                                        <span>{t('cart.value_details.payment_methods')}</span>
                                        {order?.payment_methods?.map((method: any, index: number) =>
                                            <div className='flex justify-between text-gray-600' key={index}>
                                                <span className='font-semibold'>{method?.name}</span>
                                                {order?.payment_methods.length > 1 && <span>{ formatCurrency(method.pivot?.amount) }</span>}
                                            </div>
                                        )}
                                    </div>

                                    <div className="grid gap-4 w-full">
                                        <CartValueDetails cart={order.cart} order={order} />
                                    </div>

                                    {isProofPaymentButtonVisible && <ButtonPrimary outline onClick={() => handleProofPayment()} className='text-sm justify-center'>{t('proof_payment.generate_receipt')}</ButtonPrimary>}
                                </div>
                            </section>
                }
            </section>

            {(order && order.cart) &&
                <Drawer open={showProofPayment}
                    title={t('proof_payment.name')}
                    className={isMobile ? 'ml-2' : ''}
                    onClose={() => setShowProofPayment(false)}
                    >
                    <ProofPayment
                        order={order}
                        showButtonOpenNewCart={false}
                    />
                </Drawer>
            }
        </>
    )
};

export default OrderDetails;
